<template>
  <div class="mall-user-page">
    <a-card title="注册用户">
      <div class="summary">当前筛选共 <b>{{ pagination.total }}</b> 名注册用户</div>
      <div class="toolbar">
        <a-input v-model.trim="query.keyword" class="filter-keyword" placeholder="昵称或手机号" allow-clear />
        <a-button-group>
          <a-button :type="quickRange === 'today' ? 'primary' : 'default'" @click="setQuickRange('today')">今日</a-button>
          <a-button :type="quickRange === '7' ? 'primary' : 'default'" @click="setQuickRange('7')">近7天</a-button>
          <a-button :type="quickRange === '30' ? 'primary' : 'default'" @click="setQuickRange('30')">近30天</a-button>
        </a-button-group>
        <a-range-picker v-model="dateRange" value-format="YYYY-MM-DD" @change="selectCustomRange" />
        <a-button type="primary" @click="search">查询</a-button>
        <a-button @click="reset">重置</a-button>
      </div>
      <a-table row-key="id" :loading="loading" :columns="columns" :data-source="rows" :pagination="pagination" @change="changePage">
        <template slot="status" slot-scope="value"><a-tag :color="value === 1 ? 'green' : 'default'">{{ value === 1 ? '正常' : '停用' }}</a-tag></template>
      </a-table>
    </a-card>
  </div>
</template>

<script>
import { getMallUserList } from '@/api'

export default {
  data() {
    return {
      loading: false, rows: [], query: {}, quickRange: '', dateRange: [],
      pagination: { current: 1, pageSize: 10, total: 0 },
      columns: [
        { title: '用户ID', dataIndex: 'id', width: 90 }, { title: '昵称', dataIndex: 'nickname' },
        { title: '注册手机号', dataIndex: 'phone' }, { title: '联系手机号', dataIndex: 'contactPhone' },
        { title: '国家区号', dataIndex: 'countryCode' }, { title: '积分', dataIndex: 'points' },
        { title: '注册时间', dataIndex: 'createdAt' }, { title: '最近登录', dataIndex: 'lastLoginAt' },
        { title: '状态', dataIndex: 'status', scopedSlots: { customRender: 'status' } }
      ]
    }
  },
  created() { this.loadData() },
  methods: {
    loadData() { this.loading = true; getMallUserList({ ...this.query, page: this.pagination.current, pageSize: this.pagination.pageSize }).then(res => { const data = res.data || {}; this.rows = data.records || []; this.pagination.total = data.total || 0 }).finally(() => { this.loading = false }) },
    search() { this.pagination.current = 1; this.loadData() },
    reset() { this.query = {}; this.dateRange = []; this.quickRange = ''; this.search() },
    changePage(page) { this.pagination.current = page.current; this.pagination.pageSize = page.pageSize; this.loadData() },
    setQuickRange(type) { const end = new Date(); const start = new Date(); if (type !== 'today') start.setDate(start.getDate() - Number(type) + 1); this.quickRange = type; this.dateRange = [this.formatDate(start), this.formatDate(end)]; this.query.startDate = this.dateRange[0]; this.query.endDate = this.dateRange[1]; this.search() },
    formatDate(value) { const year = value.getFullYear(); const month = (`0${value.getMonth() + 1}`).slice(-2); const day = (`0${value.getDate()}`).slice(-2); return `${year}-${month}-${day}` },
    selectCustomRange(values) { this.quickRange = ''; this.query.startDate = values && values[0]; this.query.endDate = values && values[1] }
  }
}
</script>

<style scoped>
.mall-user-page{padding:20px}.summary{margin-bottom:16px;color:#4b5563}.summary b{color:#1677ff;font-size:20px}.toolbar{margin-bottom:16px;display:flex;align-items:center;flex-wrap:wrap;gap:10px}.filter-keyword{flex:0 0 220px;width:220px;max-width:100%}
</style>
